//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { mapState, mapMutations } from 'vuex'
  import Activity from '../../components/activity/Activity'
  import { activityList } from '../../service/index'

  export default {
    data(){
      return {
        campaignList: [],
      }
    },
    components:{
      Activity
    },
    mounted() {
      this.getCampaignList()
      this.keepLang()
    },
    computed:{
      ...mapState([
        "global"
      ])
    },
    methods:{
       ...mapMutations({
        chooseCampaign: 'INIT_CAMPAIGN',
        initCampaignList:'INIT_CAMPAIGN_LIST'
      }),
      async getCampaignList(){
        const res = await activityList();
        if(res.status === 0){
          this.campaignList = res.data;
          this.initCampaignList(res.data)
        }
      },
      // 中英文切换事件
      switchLang() {
        if (this.$i18n.locale === 'en') {
          this.$i18n.locale = 'zh';
          localStorage.locale = 'zh';
        } else {
          this.$i18n.locale = 'en';
          localStorage.locale = 'en';
        }
      },
      // 刷新页面保存语言
      keepLang() {
        let locale = localStorage.locale;
        this.$i18n.locale = locale === 'en' ? locale : 'zh';
        this.$i18n.locale = 'en';
      },
      openPop(id){
        //this.chooseCampaign({id})
        this.$router.push({
          path: `/home/${id}`,
          query: { cid: id}
        })
      }
    }
  }



// WEBPACK FOOTER //
// ./src/pages/activity/Activity.vue